<template>
    <div class="m-2">
          <BRow>

            <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>
              <vSelect :value="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" @input="updatePerPage($event)" />
              <label>entradas</label>
            </BCol>

            <BCol cols="12" md="8" lg="7" xl="6">
              <slot />
            </BCol>

          </BRow>
    </div>
</template>

<script>
import vSelect  from 'vue-select'
import { BButton, BCol, BRow } from 'bootstrap-vue'

export default {
    props: [
        'perPageOptions', 'perPage'
    ],
    components: {
        BButton, BCol, BRow, vSelect
    },
    setup(props, { emit }) {
      const updatePerPage = function(event) {
        emit('update:perPage', event)
      }

      return {
        updatePerPage
      }
    },
}
</script>